export default __webpack_public_path__ + "static/media/ENTRER-UNE ADRESSE.93d6d663.svg";